import { useEffect, useState } from 'react';
import { useYandexApiKeys } from 'shared/hooks';
import { getYandexData, loadYmapsApi } from '../utils';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { YMAPS_MODULES } from '../constants';
import { TYandexMaps } from '../types';

export const useYmaps = () => {
  const { logger } = useApplicationContext();
  const [yandexMaps, setYandexMaps] = useState<TYandexMaps>(null);

  const { yandexApiKey, yandexSuggestApiKey } = useYandexApiKeys();

  useEffect(() => {
    if (!yandexApiKey || !yandexSuggestApiKey) {
      return;
    }

    getYandexData({
      request: loadYmapsApi({ apiKey: yandexApiKey, suggestApiKey: yandexSuggestApiKey, modules: YMAPS_MODULES }),
      onSuccess: setYandexMaps,
      onError: error => logger.error(error, { degradation: 'Ошибка загрузки яндекс-карт в блоке панорамы' }),
    });
  }, [logger, yandexApiKey, yandexSuggestApiKey]);

  return yandexMaps;
};
